import React from 'react';
import { webFormatCurrency } from '@rb-serve-app/core';
import RadioCard from './RadioCard';

interface EppOptionCardProps {
  termMonths: number | string;
  monthlyPaymentAmount: number | string;
  apr: number | string;
  numberOfPayments: number | string;
  isSelected: boolean;
  onSelect: () => void;
  lang?: string;
  className?: string;
  rbWebConfig?: any;
}

const EppOptionCard: React.FC<EppOptionCardProps> = ({
  termMonths,
  monthlyPaymentAmount,
  apr,
  numberOfPayments,
  isSelected,
  onSelect,
  lang = 'en-US',
  className = '',
  rbWebConfig,
}) => {
  const title = rbWebConfig?.monthTermLabel?.replace('%s', termMonths);

  const formatPaymentAmount = () => {
    if (typeof monthlyPaymentAmount === 'number') {
      return webFormatCurrency(monthlyPaymentAmount, lang);
    }
    if (
      typeof monthlyPaymentAmount === 'string' &&
      !isNaN(Number(monthlyPaymentAmount))
    ) {
      return webFormatCurrency(Number(monthlyPaymentAmount), lang);
    }
    return monthlyPaymentAmount;
  };

  return (
    <RadioCard
      title={title}
      isSelected={isSelected}
      onSelect={onSelect}
      className={className}
    >
      {/* Monthly Payment Amount - prominent display */}
      <div className="mb-4">
        <div className="flex justify-between items-center mb-3">
          <span
            className="text-[#666666] text-[14px] leading-[18px]"
            aria-label={rbWebConfig?.monthlyPaymentAmountLabel}
          >
            {rbWebConfig?.monthlyPaymentAmountLabel}
          </span>
          <span className="text-[#1F1F1F] text-[20px] font-bold leading-[30px]">
            {formatPaymentAmount()}
          </span>
        </div>
        {/* Separator line */}
        <div className="h-[1px] bg-[#E9E9E9] w-full"></div>
      </div>

      {/* APR */}
      <div className="mb-4">
        <div className="flex justify-between items-center mb-3">
          <span
            className="text-[#666666] text-[14px] leading-[18px]"
            aria-label={rbWebConfig?.aprLabel}
          >
            {rbWebConfig?.aprLabel}
          </span>
          <span className="text-[#1F1F1F] text-[16px] font-medium leading-[20px]">
            {apr}%
          </span>
        </div>
        {/* Separator line */}
        <div className="h-[1px] bg-[#E9E9E9] w-full"></div>
      </div>

      {/* Number of payments */}
      <div>
        <div className="flex justify-between items-center">
          <span
            className="text-[#666666] text-[14px] leading-[18px]"
            aria-label={rbWebConfig?.numberOfPaymentsLabel}
          >
            {rbWebConfig?.numberOfPaymentsLabel}
          </span>
          <span className="text-[#1F1F1F] text-[16px] font-medium leading-[20px]">
            {numberOfPayments}
          </span>
        </div>
      </div>
    </RadioCard>
  );
};

export default EppOptionCard;
